<div  class="dialog-title">Search Patient</div>

<div class="dialog-content">
  <p class="dialog-description">Search by name, UHID, or phone number.</p>

  <!-- Search Input -->
  <div class="search-container">
    <app-form-input label="Search" class="search-field" [(ngModel)]="searchText" placeholder="Enter name, UHID or phone..." (keyup.enter)="handleSearch()"></app-form-input>
    <button
      
     
      (click)="handleSearch()"
      [disabled]="isSearching"
      class="btn btn-primary search-button"
    >
      @if (isSearching) {
        <onevedai-spinner size="md"></onevedai-spinner>
      } @else {
        Search
      }
    </button>
  </div>

  <!-- Results Table -->
  <div class="results-container">
    @if (filteredPatients.length === 0 && !isSearching) {
      <p class="no-results">No patients found.</p>
    } @else {
      <table class="data-table patients-table"><thead><tr><th>Name</th><th>UHID</th><th>Phone</th><th>Action</th></tr></thead><tbody>@for (patient of filteredPatients; track $index) {<tr  ><td>{{ patient.name }}</td><td>{{ patient.code }}</td><td>{{ patient.contactNumber }}</td><td>
            <button
              
             
              (click)="selectPatient(patient)"
              class="btn btn-primary select-button"
            >
              Select
            </button>
          </td></tr>}</tbody></table>
    }
  </div>
</div>

<div class="dialog-actions">
  <button  (click)="cancel()" class="btn btn-text">Cancel</button>
</div>
